<style lang="stylus">
    // iview 对话框定制
    .ivu-modal-wrap
        display: flex;
        align-items: center;
        justify-content: center;
        .ivu-modal
            top: 0;
        .ivu-modal-body
            font-size 14px
            padding 8px 16px
        .ivu-modal-header
            padding: 11px 24px;
            border none
            .ivu-modal-header-inner
                color #000
                font-size 14px
        .ivu-modal-footer
            border none
            padding 8px 18px 16px 18px
    .modal-no-mask
        .ivu-modal-mask
            background none
    .ivu-modal-wrap{
        .ivu-modal-content{
          border-radius: 8px;
          border: 1px solid rgba(0, 0, 0, 0.04);
          box-shadow: 0px 15px 30px rgba(0, 0, 0, 0.15);
        }
        .ivu-modal-close{
          top: -2px;
          right: 2px;
        }
        .ivu-modal-header{
          padding: 11px 24px;
          border none;
          .ivu-modal-header-inner{
            color #000
            font-size 14px
          }
        }
    }
</style>

<template>
    <Modal
        v-model="showModal"
        :title="$t('collectTitle')"
        width="300"
        :mask-closable="false"
        class-name="vertical-center-modal"
        class="modal-no-mask"
    >
        <p style="color: #000">{{ $t("collectTips") }}</p>
        <div slot="footer">
            <!-- <Button type="text" @click="handleCancel">{{ $t("knew") }}</Button> -->
            <Button type="primary" @click="handleOk" style="background-color: #006dff">{{ $t("goCheck") }}</Button>
        </div>
    </Modal>
</template>

<script lang="ts">
    import { Component, Prop, Vue, Watch } from "vue-property-decorator";
    @Component
    export default class CollectModal extends Vue {
        get userInfo() {
            return this.$store.state.userInfo;
        }
        get showModal() {
            return this.$store.state.collectModal;
        }
        set showModal(val) {
            this.$store.commit("setState", {
                type: "collectModal",
                data: val,
            });
        }
        handleCancel() {
            this.showModal = false;
        }
        handleOk() {
            let id = this.userInfo.user_id;
            if (this.isPC && this.internal) {
                this.$store.commit("toVisitUser", {
                    id,
                });
                this.$store.commit("toTplCenter", {
                    name: "showUserWorks",
                    data: true,
                });
                this.$store.commit("toTplCenter", {
                    name: "activedTab",
                    data: 1,
                });
            } else {
                let path = this.internal ? "templates/user" : "templates/users";
                let href = `${window.location.origin}/${path}/${id}?tab=1`;
                if (this.isPC) {
                    (<any>window).$qt.jsCallOpenUrl(href);
                } else {
                    window.open(href);
                }
            }
            this.handleCancel();
        }
    }
</script>

<i18n>
{
  "zh": {
    "collectTitle": "收藏成功",
    "collectTips": "模板已保存到【模板收藏】",
    "knew": "我知道了",
    "goCheck": "前往查看"
  },
  "en": {
    "collectTitle": "Collect successfully",
    "collectTips": "The template has been saved to [My Homepage - Favorites]",
    "knew": "Got it!",
    "goCheck": "Go"
  },
  "de": {
    "collectTitle": "erfolgreich sammeln",
    "collectTips": "Die Vorlage wurde unter [Meine Homepage - Favoriten] gespeichert.",
    "knew": "我知道了",
    "goCheck": "zur Ansicht gehen"
  },
  "fr": {
    "collectTitle": "recueillir avec succès",
    "collectTips": "Le modèle a été enregistré dans [Ma page d'accueil - Favoris]",
    "knew": "我知道了",
    "goCheck": "aller voir"
  },
  "es": {
    "collectTitle": "recoger con éxito",
    "collectTips": "La plantilla se ha guardado en [Mi página de inicio - Favoritos]",
    "knew": "我知道了",
    "goCheck": "ir a ver"
  },
  "jp": {
    "collectTitle": "正常に収集",
    "collectTips": "テンプレートが[マイホームページ-お気に入り]に保存されました",
    "knew": "我知道了",
    "goCheck": "表示に移動"
  },
  "pt": {
    "collectTitle": "coletar com sucesso",
    "collectTips": "O modelo foi salvo em [Minha página inicial - Favoritos]",
    "knew": "我知道了",
    "goCheck": "vá para ver"
  },
  "it": {
    "collectTitle": "raccogliere con successo",
    "collectTips": "Il modello è stato salvato in [My Homepage - Favorites]",
    "knew": "我知道了",
    "goCheck": "vai a vedere"
  },
  "tw": {
    "collectTitle": "收藏成功",
    "collectTips": "模板已保存到 【我的主頁-收藏】",
    "knew": "我知道了",
    "goCheck": "前往查看"
  },
  "kr": {
    "collectTitle": "성공적으로 수집",
    "collectTips": "템플릿이 [내 홈페이지 - 즐겨찾기]에 저장되었습니다.",
    "knew": "我知道了",
    "goCheck": "보러가기"
  },
  "id": {
    "collectTitle": "Berhasil mengumpulkan",
    "collectTips": "Templat telah disimpan ke [Halaman Utama Saya - Favorit]",
    "knew": "Mengerti!",
    "goCheck": "Mulai"
  }
}
</i18n>
